import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";
import { SubmitContactUsFormApiParameter } from "@insite/client-framework/Services/EmailService";
import { TellAFriendModel } from "@insite/client-framework/Types/ApiModels";

const emailsUrlV2 = "/api/v2/email";

export interface TellAFriendApiParameter extends ApiParameter {
    tellAFriendModel: TellAFriendModel;
}

export function tellAFriend(parameter: TellAFriendApiParameter) {
    return post<TellAFriendModel>(`${emailsUrlV2}/tellafriend`, parameter.tellAFriendModel);
}


export function niscoSubmitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    return post<SubmitContactUsFormApiParameter, void>(`${emailsUrlV2}/contactUs`, parameter);
}